import React, { useEffect, useState } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { AdminButton } from "../../../components/buttons/versionHistoryBtn";
import back from "../../../assets/back.svg";
import "../customers.css";
import { useDispatch, useSelector } from "react-redux";
import {
  customerProductOfferRequestApproveReject,
  customerProductOfferRequestView,
  customerRemoveProductOffer,
  ProductOfferRequestApproveAll,
  productOfferRequestList,
  ProductOfferRequestRejectAll,
} from "../../../redux/actions/customerActions";

import ErrorPopup from "../../../components/popups/ErrorPopup";
import LoadingSpinnerTable from "../../../components/utilites/loader";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";
import moment from "moment";
import UpdateProductOfferModal from "../../../components/modals/Customer/updateProductOfferReqModal";
import ChangeSaved from "../../../components/popups/ChangeSaved";
import OffersDetailTable from "./offerDetailsTable";

const ProductOfferRequestView = () => {
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const [subscribeReqData, setSubscribeReqData] = useState(null);
  const [approveShow, setApproveShow] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [onSuccessShow, onSetSuccessShow] = useState(false);
  const [onSuccessMsg, onSetSuccessMsg] = useState("");
  const [selectedRequest, setSelectedRequest] = useState(null);
  const divisionData = useSelector((state) => state.productOffersReducer);

  console.log(divisionData.productOffers, "divisionData");

  useEffect(() => {
    setLoading(true);
    dispatch(
      customerProductOfferRequestView(
        { doctor_id: params?.id },
        onSuccess,
        onError
      )
    );
  }, []);

  const onSuccess = (data) => {
    setLoading(false);
    setSubscribeReqData(data.data.data);
    dispatch(
      productOfferRequestList({
        productOffers: data.data.data.fieldForceDivisions,
      })
    );
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    setLoading(false);
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  const customerDetails = [
    {
      heading: "Jivini’s Customer Code",
      title: subscribeReqData?.doctor?.code ?? "--",
    },
    {
      heading: "Customer Name",
      title: subscribeReqData?.doctor?.name
        ? `DR. ${subscribeReqData?.doctor?.name.toUpperCase()}`
        : "--",
    },

    {
      heading: "State",
      title: subscribeReqData?.doctor?.state?.name ?? "--",
    },
    {
      heading: "District",
      title: subscribeReqData?.doctor?.district?.name ?? "--",
    },
  ];

  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/customers/product-offer-request",
      breadcrumb: " / customers / DOCTOR PRODUCT OFFERS",
    },

    {
      path: "/customers/product-offer-request/view/:id",
      breadcrumb: subscribeReqData?.request_id
        ? ` / ${subscribeReqData?.request_id} - view`
        : " / view",
    },
  ];

  const reload = () => {
    dispatch(
      customerProductOfferRequestView(
        { doctor_id: params?.id },
        onSuccess,
        onError
      )
    );
  };

  const approveAll = () => {
    dispatch(
      ProductOfferRequestApproveAll(
        { doctor_id: params?.id },
        onApproveAllSuccess,
        onApproveAllError
      )
    );
  };

  const rejectAll = () => {
    dispatch(
      ProductOfferRequestRejectAll(
        { doctor_id: params?.id },
        onApproveAllSuccess,
        onApproveAllError
      )
    );
  };

  const timeOutFnc = () => {
    onSetSuccessShow(false);
  };

  const onApproveAllSuccess = (data) => {
    console.log(data);
    onSetSuccessShow(true);
    const str = data.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    onSetSuccessMsg(str_modify);
    setTimeout(timeOutFnc, 2000);
    reload();
  };

  const onApproveAllError = (err) => {
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    setShowErrorPopup(true);
  };

  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });

  return (
    <>
      <div className="products-page">
        <div className="products-main-div">
          {breadcrumbs.map(({ match, breadcrumb }) => (
            <NavLink
              key={match.pathname}
              to={match.pathname}
              className="header-route-page fw_400 cursor_pointer"
            >
              <span className="fs_18">{breadcrumb}</span>
            </NavLink>
          ))}
          <div className="products-main-list my-2 py-1">
            <div className="search-container d-flex justify-content-between align-items-center">
              <div
                className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
                onClick={() => navigate(-1)}
              >
                <img src={back} alt="back_btn" />
                <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                  BACK
                </span>
              </div>
              <div className="d-flex justify-content-between m-1 mb-2">
                <AdminButton
                  background="#7065E4"
                  color="white"
                  width="150px"
                  onClick={approveAll}
                >
                  APPROVE ALL
                </AdminButton>

                <AdminButton
                  background="#FF6F5B"
                  color="white"
                  width="150px"
                  onClick={rejectAll}
                >
                  REJECTED ALL
                </AdminButton>
              </div>
            </div>
            <div style={{ position: "relative" }}>
              {loading == true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : (
                <div className="main-view-page">
                  <div className="mb-4">
                    <div className="d-flex text-left px-3 my-3 py-1 form-sub-details fw_600">
                      Customer Details
                    </div>
                    <div className="product-details-container ms-2 ps-1">
                      <div className="pt-3 row ">
                        <>
                          {customerDetails.map((item, index) => (
                            <div
                              key={index}
                              className="mb-2 col-10 col-sm-6 col-md-4 col-xxl-1 me-4 px-2 customers-basic-heading-container"
                            >
                              <h5 className="color_b0b3c7 text-nowrap fs_14 fw_500 m-0">
                                {item.heading}
                              </h5>
                              <p className={`fs_15 fn_Nunito fw_500`}>
                                {item.title}
                              </p>
                            </div>
                          ))}
                        </>
                      </div>
                    </div>
                  </div>
                  {divisionData.productOffers?.map((division, index) => (
                    <div className="mb-4" key={index}>
                      <div className="d-flex text-left px-3 my-3 py-1 form-sub-details fw_600">
                        Division Offer Details -{" "}
                        {division?.vendorDivision?.name}
                      </div>
                      <div className="product-details-container ms-2 ps-1">
                        <div className="pt-3 row ">
                          <>
                            <div className="mb-2 col-10 col-sm-6 col-md-4 col-xxl-2 me-4 px-2 customers-basic-heading-container">
                              <h5 className="color_b0b3c7 text-nowrap fs_14 fw_500 m-0">
                                Field Force ID
                              </h5>
                              <p className={`fs_15 fn_Nunito fw_500`}>
                                {division?.fieldForceUser?.code ?? "--"}
                              </p>
                            </div>
                            <div className="mb-2 col-10 col-sm-6 col-md-4 col-xxl-2 me-4 px-2 customers-basic-heading-container">
                              <h5 className="color_b0b3c7 text-nowrap fs_14 fw_500 m-0">
                                Field Force Name
                              </h5>
                              <p className={`fs_15 fn_Nunito fw_500`}>
                                {division?.fieldForceUser?.name ?? "--"}
                              </p>
                            </div>
                            <div className="mb-2 col-10 col-sm-6 col-md-4 col-xxl-2 me-4 px-2 customers-basic-heading-container">
                              <h5 className="color_b0b3c7 text-nowrap fs_14 fw_500 m-0">
                                Division
                              </h5>
                              <p className={`fs_15 fn_Nunito fw_500`}>
                                {division?.vendorDivision?.name ?? "--"}
                              </p>
                            </div>
                          </>
                        </div>
                      </div>
                      <div className="mx-2">
                        <OffersDetailTable
                          tableData={division?.productOffers}
                          divisionName={division?.vendorDivision.name}
                          stateName={
                            subscribeReqData?.doctor?.state?.name ?? "--"
                          }
                          districtName={
                            subscribeReqData?.doctor?.district?.name ?? "--"
                          }
                        />
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          <ChangeSaved show={onSuccessShow} title={onSuccessMsg} />
          <ErrorPopup
            show={showErrorPopup}
            title={showErrorMsg}
            handleClose={closeErrorPopup}
          />
        </div>
      </div>
    </>
  );
};

export default ProductOfferRequestView;
